module.exports = __webpack_public_path__ + "static/media/noteBlue.215e7ec2.svg";